/* global Sys, NetEntExtend, Services */
Sys.ns("NetEntExtend.API");

/**
 * Slots specific additions / overrides for Restricted NetEntExtend Setters.
 *
 * @class NetEntExtend.API.Restricted.Setters
 * @extends NetEntExtend.API.Setters.Restricted
 */
Sys.apply(NetEntExtend.API.Restricted.Setters, {

    /**
     * Sets the betlevel.
     *
     * @memberof NetEntExtend.API.Restricted.Setters
     */
    betLevel: Sys.applyPropertiesIf({
        platforms: ["desktop"],
        isAvailable: function() {
            return !(Services.gameRound.isRoundActive() || Services.freeRounds.isActive());
        },
        validateArguments: function() {
            var betLevel = parseInt(arguments[3], 10),
                betLevels = Services.bet.getBetLevels();

            return !(isNaN(betLevel) || betLevels.indexOf(betLevel) === -1);
        },
        func: function() {
            var betLevel = parseInt(arguments[3], 10);

            Services.bet.setBetLevel(betLevel);

            this.success.apply(this, arguments);
        }
    }, NetEntExtend.API.BaseSetter),

    /**
     * Sets the coin value.
     *
     * @memberof NetEntExtend.API.Restricted.Setters
     */
    coinValue: Sys.applyPropertiesIf({
        platforms: ["desktop"],
        isAvailable: function() {
            return !(Services.gameRound.isRoundActive() || Services.freeRounds.isActive());
        },
        validateArguments: function() {
            var coinValue = parseInt(arguments[3], 10),
                denominations = Services.bet.getDenominations();

            return !(isNaN(coinValue) || denominations.indexOf(coinValue) === -1);
        },
        func: function() {
            var coinValue = parseInt(arguments[3], 10);

            Services.bet.setDenomination(coinValue);

            this.success.apply(this, arguments);
        }
    }, NetEntExtend.API.BaseSetter)
});
